import {Button, ButtonGroup} from "react-bootstrap";
import React from "react";
import {Brand} from "../../config/enums";

export interface ButtonSelectOption {
    key: string | number | Brand;
    name: string;
}

interface ButtonGroupSelectProps {
    options: ButtonSelectOption[];
    value: string | number;
    onChange: Function;
    vertical?: boolean;
    verticalWhenSmaller?: boolean;
}

/**
 * Component that defines an button-based option input
 * @param {ButtonGroupSelectProps} props - The props that the ButtonGroupSelect component accepts.
 * @param {ButtonSelectOption[]} props.options - List of possible options
 * @param {string | number} props.value - Current selected value
 * @param {Function} props.onChange - Function to change the current value
 * @param {boolean} props.vertical - Boolean to use a vertical list instead of horizontal
 * @param {boolean} props.verticalWhenSmaller - Boolean that can be used for option lists that should be vertical on a smaller screen
 * @constructor
 */
const ButtonGroupSelect = (props: ButtonGroupSelectProps) => {
    const {onChange, options, value, vertical, verticalWhenSmaller} = props;

    if (verticalWhenSmaller) {
        return <div className={'btn-group-vertical-when-small'}>
            {options.map((option: ButtonSelectOption) => <Button key={option.key} variant="outline-main" onClick={() => onChange(option.key)} active={value === option.key}>{option.name}</Button>)}
        </div>
    }

    return <ButtonGroup vertical={vertical}>
        {options.map((option: ButtonSelectOption) => <Button key={option.key} variant="outline-main" onClick={() => onChange(option.key)} active={value === option.key}>{option.name}</Button>)}
    </ButtonGroup>;
}

export default ButtonGroupSelect;